import React, { useMemo } from 'react';
import Panel from '../../../../core/components/Panel';
import TabsPanel from '../../../../core/components/TabsPanel';
import ProviderEditAccountTab from './ProviderEditAccountTab';
import ProviderEditUsageTab from './ProviderEditUsageTab';
import ProviderEditChangeHistoryTab from './ProviderEditChangeHistoryTab';
import { useProviderEditFormInit } from './useProviderEditFormInit';

const ProviderEditTabs = (): JSX.Element => {
    useProviderEditFormInit();

    const tabs = useMemo(() => {
        return [
            {
                id: 'provider-edit-tab-1',
                label: 'Account',
                content: <ProviderEditAccountTab />,
            },
            {
                id: 'provider-edit-tab-2',
                label: 'Usage',
                content: <ProviderEditUsageTab />,
            },
            {
                id: 'provider-edit-tab-3',
                label: 'Change History',
                content: <ProviderEditChangeHistoryTab />,
            },
        ];
    }, []);

    return (
        <Panel
            flushTabs
            fullWidth
        >
            <TabsPanel tabs={tabs} />
        </Panel>
    );
};

export default ProviderEditTabs;
